export default __webpack_public_path__ + "static/cndf-cilium-clustermesh1-5b52b1d8d915fbf75e84c49d4c3c550f.jpg";